// extracted by mini-css-extract-plugin
module.exports = {"navItem":"NavItem_navItem___DJTk","title":"NavItem_title__2Pk27","active":"NavItem_active__3liuV"};